module.exports = __webpack_public_path__ + "img/bgc10.dee63362.png";